import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ConnectFacebookDialogComponent } from './connect-facebook-dialog.component'

@Injectable()
export class ConnectFacebookDialogService {
  constructor(private dialog: MatDialog) {}

  public open() {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      panelClass: ['fixed-modal', 'no-scroll-modal'],
    }

    return this.dialog.open(ConnectFacebookDialogComponent, defaultConfig)
  }
}
